/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/

import React from "react";
import { CentreContents } from "@tol/tol-ui";
import { Link } from "react-router-dom";

import "../../scss/legacy-tol.scss";

const LegacyHome: React.FC = () => {
  return (
    <div style={{ backgroundColor: "white", color: "black", minWidth: "100%" }}>
      <CentreContents>
        <header className="header">
          <h1 className="header-h1">Tree of sex</h1>
          <h2 className="header-h2">
            a database of eukaryotic sex determination systems
          </h2>
          <nav className="nav">
            <span>Home</span>
            <Link className="link" to={"/legacy-consortium"}>
              Consortium{" "}
            </Link>
            <Link className="link" to={"/legacy-database"}>
              Database{" "}
            </Link>
            <Link className="link" to={"/legacy-publications"}>
              Publications{" "}
            </Link>
          </nav>
        </header>

        <main className="legacy-main">
          <div className="imgs">
            <img alt="tree of sex logo" src="/legacy/treeofsexlogo.jpg" />{" "}
            <img alt="Pasted Graphic" src="/legacy/pasted-graphic.jpg" />
          </div>
          <p>
            Sex is universal among living organisms, yet a mind-boggling
            diversity of mechanisms that determine the sex of an individual
            exists. These include chromosomal sex determination (such as in
            humans, where males have an X and a Y chromosome, and females have
            two X chromosomes), environmental sex determination (such as in many
            reptiles, where environmental cues - such as temperature - determine
            sex), or haplo-diploid sex determination (where fertilized eggs
            develop as females, and unfertilized eggs develop as males - such as
            in bees), amongst others. While some taxonomic groups (such as
            mammals and birds) have stable sex determination mechanisms, in
            other taxa (such as insects and fish), sex determination mechanisms
            can vary greatly among closely related species, or even among
            individuals within a species.
          </p>
          <div className="imgs">
            <img alt="Slide1" src="/legacy/slide1.jpg" />
          </div>
          <p>
            This variation is surprising, given that sex determination is a
            fundamental biological process. The evolutionary forces that drive
            this variation of sex determination systems are not understood. The
            "
            <Link className="link" to={"/legacy-consortium"}>
              Tree of Sex Consortium
            </Link>
            " has assembled a{" "}
            <Link className="link" to={"/legacy-database"}>
              database
            </Link>{" "}
            which is listing sexual systems and sex determination mechanisms
            across the eukaryotic tree of life. By synthesizing existing data on
            sexual systems, the database allows biologists to identify the
            evolutionary and ecological processes that underlie the remarkable
            diversity in sexual systems across the tree of eukaryotic life.
          </p>
        </main>
        <footer className="legacy-footer">
          <p>
            &copy; 2014 Tree of Sex Consortium :{" "}
            <Link to={"/legacy-cookies-policy"}>Cookies Policy</Link>
          </p>
        </footer>
      </CentreContents>
    </div>
  );
};
export default LegacyHome;
